import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboardCable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"keyboard-cable"} maskId="square-filled-radius-0-stroke-1-IconKeyboardCable"><path fillRule="evenodd" clipRule="evenodd" d="M19 5V2H18V4H5V8H1V22H23V8H6V5H19ZM9 16.75H15V17.75H9V16.75ZM6.5 12H5V13.5H6.5V12ZM5 16.5H6.5V18H5V16.5ZM10.5 12H9V13.5H10.5V12ZM13.5 12H15V13.5H13.5V12ZM19 12H17.5V13.5H19V12ZM17.5 16.5H19V18H17.5V16.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconKeyboardCable;
